export default __webpack_public_path__ + "c94586f8baeb73cbf06b26279692494a.png";